export const services = [
    {
        id: 0.03,
        icon: "fas fa-diagnoses",
        title: "Artistic Fabriction",
        content: "We aims to WOW our customers with our creations! Our artistic services relates to the production of large or technically difficult work."
    },
    {
        id: 0.05,
        icon: "fas fa-shapes",
        title: "Customizable",
        content: "Our products are custom-tailored, allowing us to offer our clients a wide variety of shapes, sizes and fabrics."
    },
    {
        id: 0.07,
        icon: "fas fa-balance-scale",
        title: "Quality",
        content: "We offer both commercial and residential services, providing quality grade steel. We will fabricate and install according to the disigner's specifications."
    },
    {
        id: 0.09,
        icon: "fas fa-dice-d20",
        title: "Smart Design",
        content: "We can enhance your home or business with stylish and practical stainless steel style counter tops and moldings."
    }
]

export const products = [
    {
        id: 1,
        name: "Hand Rails",
        img: "/images/handrail2.jpg"
    },
    {
        id: 2,
        name: "Gates",
        img: "/images/ssgates.jpg"
    },
    {
        id: 3,
        name: "Balcony",
        img: "/images/balcony.jpg"
    },
    {
        id: 4,
        name: "Swing",
        img: "/images/swing.jpg"
    },
    {
        id: 5,
        name: "Safety Grills",
        img: "/images/safety-grill.jpg"
    }
]